import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";
import { Button } from "components/common/Button";
import { ConfirmActionModal } from "../ConfirmActionModal";
import type { DetectLayoutButtonProps } from "./types";

export const DetectLayoutButton = ({ onDetect }: DetectLayoutButtonProps) => {
  const { t } = useTranslation();

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const openConfirm = useCallback(() => setIsConfirmOpen(true), []);
  const closeConfirm = useCallback(() => setIsConfirmOpen(false), []);

  return (
    <>
      <Button
        size="sm"
        variant="primary"
        onClick={openConfirm}
        startAdornment={<Sparkles size={14} />}
        className="w-full gap-1.5 rounded-full"
      >
        {t("smartSurveyor.layoutDetection.button")}
      </Button>
      <ConfirmActionModal
        isOpen={isConfirmOpen}
        onClose={closeConfirm}
        onConfirm={onDetect}
        action="detect"
        title={t("smartSurveyor.layoutDetection.confirmTitle")}
        description={t("smartSurveyor.layoutDetection.confirmDescription")}
      />
    </>
  );
};
